import { EmployeeForSelectFragment } from 'generated/resources/graphql'
import { RefinementCtx, z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export interface SuperRefineContext {
  data: {
    category?: string | null
    [key: string]: unknown
  }
  ctx: RefinementCtx
  customizationFields: CustomizationField[]
}

// FormContext contains the auxiliary data that is needed for validation, in this case is the customizationFields
export interface FormContext {
  customizationFields: CustomizationField[]
}

export const BasicInformationSchema = ({ customizationFields }: FormContext) => {
  return z.object({
    employee: z.custom<EmployeeForSelectFragment>().optional().nullable(),
    currency: z
      .string()
      .optional()
      .refine(
        (currency) => (isMandatory('currency', 'expense', customizationFields) ? !!currency : true),
        defaultRequiredMessage()
      ),
    amount: z.number({ required_error: i18n.t('expenses_v2.forms.errors.required') }),
    documentNumber: z
      .string()
      .optional()
      .refine(
        (docNumber) =>
          isMandatory('document_number', 'expense', customizationFields) ? !!docNumber : true,
        defaultRequiredMessage()
      ),
    documentType: z
      .string()
      .optional()
      .refine(
        (documentType) =>
          isMandatory('document_type', 'expense', customizationFields) ? !!documentType : true,
        defaultRequiredMessage()
      ),
    effectiveOn: z
      .string()
      .optional()
      .refine(
        (effectiveOn) =>
          isMandatory('effective_on', 'expense', customizationFields) ? !!effectiveOn : true,
        defaultRequiredMessage()
      ),
  })
}

export type BasicInformationSchema = z.infer<ReturnType<typeof BasicInformationSchema>>
